import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  TextField,
  Paper,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import {
  apiEndpoints,
  apiPutRequest,
  apiDeleteRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import {
  addCreatedAndUpdatedFields,
  addVoteStatisticField,
} from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import CancelIcon from "@material-ui/icons/Cancel";
import { kmMessages } from "src/constant/Messages";
import KmTabPanel from "src/components/common/KmTabPanel";
import TabsNavBar from "../TabsNavBar";
import ReasonTooltip from "../ReasonTooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TimerIcon from "@material-ui/icons/Timer";
import DescriptionIcon from "@material-ui/icons/Description";
import EmailIcon from "@material-ui/icons/Email";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { fillMissingTags } from "src/utils/utils";

const cancelResonMaxLength = 2000;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      {!row.documentNotApplicable && row.documentStructNodeId ? (
        <Tooltip title="Dokumenty">
          <IconButton
            aria-label="dokumenty"
            component={RouterLink}
            to={`/dokumenty/${row.documentStructNodeId}`}
          >
            <DescriptionIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
      <Tooltip title="Podgląd">
        <IconButton
          aria-label="podgląd"
          component={RouterLink}
          to={`/zarzadzanieglosowania/podgladglosowania/${row.id}`}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Przypomnij">
        <IconButton
          aria-label="Przypomnij"
          component={RouterLink}
          to={`/powiadomienieglosowania/${row.id}`}
        >
          <EmailIcon />
        </IconButton>
      </Tooltip>
      {row.relatedCount === 0 ? (
        <Tooltip title="Wycofaj">
          <IconButton
            aria-label="anuluj"
            onClick={() => customHandlers.backHandler(row)}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Box>
          <Tooltip title="Zakończ">
            <IconButton
              aria-label="zakończ"
              onClick={() => customHandlers.stopHandler(row)}
            >
              <TimerIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Anuluj">
            <IconButton
              aria-label="anuluj"
              onClick={() => customHandlers.cancelHandler(row)}
            >
              <CancelIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

const Votings = ({ enableGlobalLoader, disableGlobalLoader, setLogoutUser }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const [dialogCancelOpen, setCancelOpen] = useState(false);
  const [canceledVoting, setCanceledVoting] = useState(null);
  const [cancelReason, setCancelReason] = useState(null);
  const [cancelReasonError, setCancelReasonError] = useState(null);
  const [dialogBackOpen, setBackOpen] = useState(false);
  const [backedVoting, setBackedVoting] = useState(null);
  const [dialogStopOpen, setStopOpen] = useState(false);
  const [stoppedVoting, setStoppedVoting] = useState(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(
      apiEndpoints.getManagmentVotings.path,
      "in_progress",
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addVoteStatisticField(
            addCreatedAndUpdatedFields(
              data,
              "createdBy",
              "createdAt",
              "updatedBy",
              "updatedAt",
              ", "
            )
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  const cancelHandler = (row) => {
    setCanceledVoting(row);
    handleClickCancelOpen(row);
  };

  const backHandler = (row) => {
    setBackedVoting(row);
    handleClickBackOpen(row);
  };

  const stopHandler = (row) => {
    setStoppedVoting(row);
    handleClickStopOpen(row);
  };

  const headCells = [
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: { cancelHandler, backHandler, stopHandler },
      component: RowButtons,
      width: "10%",
    },{
      id: "title",
      numeric: false,
      disablePadding: false,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
      width: "25%",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: false,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
      width: "8%",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: false,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
      width: "8%",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
      width: "8%",
    },
    {
      id: "updated",
      fieldName: "updatedAt",
      fieldName2: "updatedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zmodyfikował",
      width: "8%",
    },
    {
      id: "actionReason",
      numeric: false,
      disablePadding: false,
      sortable: true,
      component: ReasonTooltip,
      label: "Uzasadnienie",
      width: "15%",
    }
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    apiDeleteRequest(apiEndpoints.deleteVotings.path, selectedRowIds, true)
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/zarzadzanieglosowania/wtrakcie");
      });
  };

  const handleClickCancelOpen = () => {
    setCancelReasonError(null);
    setCancelReason(null);
    setCancelOpen(true);
  };

  const handleCancelDialogClose = () => {
    setCancelOpen(false);
  };

  const handleCancel = () => {
    enableGlobalLoader();

    if (cancelReason?.length > 0) {
      if (cancelReason.length > cancelResonMaxLength) {
        setCancelReasonError(
          formValidation.maxLength.replaceAll("{maxlen}", cancelResonMaxLength)
        );
      } else {
        if (canceledVoting) {
          apiPutRequest(
            apiEndpoints.setVotingStatus.path,
            {
              id: canceledVoting.id,
              action: "cancel",
              reason: cancelReason,
            },
            true
          )
            .then((data) => {
              disableGlobalLoader();
              setCancelOpen(false);

              navigate("/zarzadzanieglosowania/anulowane");
            })
            .catch((error) => {
              disableGlobalLoader();
              if (error.response && error.response.status === 401) {
                setLogoutUser();
              }
            });
        } else {
        }
      }
    } else {
      setCancelReasonError(formValidation.required);
      disableGlobalLoader();
    }
  };

  const handleCancelReasonChange = (event) => {
    if (event.target.value.length > cancelResonMaxLength) {
      setCancelReasonError(
        formValidation.maxLength.replaceAll("{maxlen}", cancelResonMaxLength)
      );
    } else {
      setCancelReasonError(null);
    }
    setCancelReason(event.target.value);
  };

  const handleClickBackOpen = () => {
    setBackOpen(true);
  };

  const handleBackDialogClose = () => {
    setBackOpen(false);
  };

  const handleBack = () => {
    if (backedVoting) {
      enableGlobalLoader();

      apiPutRequest(
        apiEndpoints.setVotingStatus.path,
        {
          id: backedVoting.id,
          action: "back",
          reason: "back",
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setBackOpen(false);

          setReloadCounter(reloadCounter + 1);

        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    } else {
    }
  };

  const handleClickStopOpen = () => {
    setStopOpen(true);
  };

  const handleStopDialogClose = () => {
    setStopOpen(false);
  };

  const handleStop = () => {
    if (stoppedVoting) {
      enableGlobalLoader();

      apiPutRequest(
        apiEndpoints.setVotingStatus.path,
        {
          id: stoppedVoting.id,
          action: "finish",
          reason: "finish",
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setStopOpen(false);

          setReloadCounter(reloadCounter + 1);

        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    } else {
    }
  };

  return (
    <Page className={classes.root} title="Głosowania w trakcie">
      <KmPageTitle>Głosowania</KmPageTitle>
      <Container maxWidth={false}>
        <Paper>
          <TabsNavBar value={1} />
          <KmTabPanel value={1} index={1}>
            <Page className={classes.root}>
              <Container maxWidth={false}>
                <KmFilteredTable
                  markable={false}
                  headCells={headCells}
                  rows={rows}
                  onSelectedRowIdsChange={onSelectedRowIdsChanged}
                />
                <Dialog
                  fullScreen={fullScreen}
                  open={dialogOpen}
                  onClose={handleClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Usuwanie głosowań"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Czy na na pewno chcesz usunąć zaznaczone elementy?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                      Nie
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                      Tak
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={fullScreen}
                  open={dialogCancelOpen}
                  onClose={handleCancelDialogClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Anulowanie głosowania"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Czy na na pewno chcesz anulować głosowanie "
                      {canceledVoting ? canceledVoting.title : "-"}"?
                    </DialogContentText>
                    <TextField
                      multiline
                      error={cancelReasonError?.length > 0}
                      helperText={cancelReasonError}
                      margin="dense"
                      id="cancelreason"
                      value={cancelReason}
                      onChange={handleCancelReasonChange}
                      label="Uzasadnienie anulowania"
                      type="text"
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={handleCancelDialogClose}
                      color="primary"
                    >
                      Nie
                    </Button>
                    <Button onClick={handleCancel} color="primary" autoFocus>
                      Tak
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={fullScreen}
                  open={dialogBackOpen}
                  onClose={handleBackDialogClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Wycofanie głosowania"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Czy na na pewno chcesz wycofać głosowanie "
                      {backedVoting ? backedVoting.title : "-"}"?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={handleBackDialogClose}
                      color="primary"
                    >
                      Nie
                    </Button>
                    <Button onClick={handleBack} color="primary" autoFocus>
                      Tak
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={fullScreen}
                  open={dialogStopOpen}
                  onClose={handleStopDialogClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Zakończenie głosowania"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Czy na na pewno chcesz zakończyć głosowanie "
                      {stoppedVoting ? stoppedVoting.title : "-"}"?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={handleStopDialogClose}
                      color="primary"
                    >
                      Nie
                    </Button>
                    <Button onClick={handleStop} color="primary" autoFocus>
                      Tak
                    </Button>
                  </DialogActions>
                </Dialog>
              </Container>
            </Page>
          </KmTabPanel>
        </Paper>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(Votings);
